import { render } from "./Proveedormodal.vue?vue&type=template&id=78ef646e"
import script from "./Proveedormodal.vue?vue&type=script&lang=js"
export * from "./Proveedormodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__